import { create } from 'zustand';
import dayjs from 'dayjs';

const useSellStore = create((set) => ({
  // Estado inicial
  sell: {
    date: dayjs(),
    pet: null,
    owner: null,
    items: [],
    payments: [],
    total: 0,
    debt: 0,
    deposit: null,
    sell_point: null,
  },

  sellItem: {
    product: null,
    price: '',
    quantity: '',
    discount_surcharge: '',
    selected_unit: '',
  },

  paymentItem: {
    finance_types_payment: null,
    amount: '',
  },

  // Acciones
  setSell: (sell) => set({ sell }),
  setSellItem: (sellItem) => set({ sellItem }),
  setPaymentItem: (paymentItem) => set({ paymentItem }),

  // Acciones específicas
  updateSell: (updates) => set((state) => ({
    sell: { ...state.sell, ...updates }
  })),

  addItem: (item) => set((state) => ({
    sell: {
      ...state.sell,
      items: [...state.sell.items, item]
    }
  })),

  removeItem: (index) => set((state) => ({
    sell: {
      ...state.sell,
      items: state.sell.items.filter((_, i) => i !== index)
    }
  })),

  addPayment: (payment) => set((state) => ({
    sell: {
      ...state.sell,
      payments: [...state.sell.payments, payment]
    }
  })),

  removePayment: (index) => set((state) => ({
    sell: {
      ...state.sell,
      payments: state.sell.payments.filter((_, i) => i !== index)
    }
  })),

  resetSellItem: () => set({
    sellItem: {
      product: null,
      price: '',
      quantity: '',
      discount_surcharge: '',
      selected_unit: '',
    }
  }),

  resetPaymentItem: () => set({
    paymentItem: {
      finance_types_payment: null,
      amount: '',
    }
  }),

  resetSell: () => set({
    sell: {
      date: dayjs(),
      pet: null,
      owner: null,
      items: [],
      payments: [],
      total: 0,
      debt: 0,
      deposit: null,
      sell_point: null,
    },
    sellItem: {
      product: null,
      price: '',
      quantity: '',
      discount_surcharge: '',
      selected_unit: '',
    },
    paymentItem: {
      finance_types_payment: null,
      amount: '',
    }
  })
}));

export default useSellStore; 